import axios from "axios";
import config from "../config";
import PlayerInterface from "../interfaces/Player.interface";

export const registerPlayer = ({ name, password }: { name: string, password: string }) => axios.post(`${config.API_URL}/players/create`, {
    name, password
})

export const playerLogin = ({ name, password }: { name: string, password: string }) => axios.post(`${config.API_URL}/players/login`, {
    name, password
})

export const searchPlayer = ({ search }: { search: string }) => axios.post(`${config.API_URL}/players/search`, { search })

export const getPlayerStats = (name: string) => axios.get(`${config.API_URL}/players/stats/${name || ""}`)
export const getSeasonPlayerStats = (name: string, seasonName: string = "") => axios.get(`${config.API_URL}/players/stats/${name}/${seasonName}`)
export const getAllPlayers = () => axios.get(`${config.API_URL}/players/list`)
export const getPlayer = ({ name }: { name?: string }) => axios.get(`${config.API_URL}/players/${name || ""}/data`,)
export const getPlayerData = ({ token }: { token: string }) => axios.get(`${config.API_URL}/players/data`, {
    headers: {

        Authorization: `Bearer ${token}`
    }
})

export const getHistoricalBestPlayers = () => axios.get(`${config.API_URL}/players/top/historical`)
export const getSeasonBestPlayers = () => axios.get(`${config.API_URL}/players/top/season`)
export const updatePlayerData = ({ data, token }: { data: PlayerInterface, token: string }) => axios.patch(`${config.API_URL}/players`, data, {
    headers: {
        Authorization: `Bearer ${token}`
    }
})

export const getPlayerContracts = (token: string) => axios.get(`${config.API_URL}/players/contracts`,
    {
        headers: {
            Authorization: `Bearer ${token}`
        }
    }
)